import { useCallback } from 'react';
import sendWithContextRefs from '../../application/composer/send.js';

export {
  isSourcingRefreshCommand,
  resolveOutboundContent,
  resolveSendAttachmentPayloadRefs,
  resolveSendAttachmentRefs,
  resolveSourceGroundingMessage,
  resolveSourcingPayloadExtra,
} from '../../application/composer/context-input.js';

export function useSendWithContextRefs({
  composerModeKey,
  sourceItems,
  composer,
  activeWorkspaceTab,
  setActiveWorkspaceTab,
  composerFileListRef,
  hasNonReadyAttachments,
  readyAttachmentRefs,
  latestSourcingQuery = '',
  latestSourcingResultIds = [],
  savedIntakeCanvasContent = '',
  activeArtifactTarget = null,
} = {}) {
  return useCallback((options = {}) => sendWithContextRefs(options, {
    activeArtifactTarget,
    activeWorkspaceTab,
    composer,
    composerFileListRef,
    composerModeKey,
    hasNonReadyAttachments,
    readyAttachmentRefs,
    setActiveWorkspaceTab,
    sourceItems,
    latestSourcingQuery,
    latestSourcingResultIds,
    savedIntakeCanvasContent,
  }), [
    activeArtifactTarget,
    activeWorkspaceTab,
    composer,
    composerFileListRef,
    composerModeKey,
    hasNonReadyAttachments,
    latestSourcingQuery,
    latestSourcingResultIds,
    readyAttachmentRefs,
    savedIntakeCanvasContent,
    setActiveWorkspaceTab,
    sourceItems,
  ]);
}

export default useSendWithContextRefs;
